<span *ngIf="account.account_role !== 'manager'">{{
  ucFirst(account.account_role)
}}</span>
<a
  *ngIf="account.account_role === 'manager'"
  href="javascript:"
  (click)="openDialog()"
  >{{ ucFirst(account.account_role) }}</a
>
